import PropTypes from 'prop-types'
const { Typography } = require('@material-tailwind/react')

export const Pill = ({ label, value }) => {
  return (
    <div className='px-4 py-2 bg-blue-50 rounded-[48px] justify-start items-center gap-4 inline-flex'>

      <Typography variant='small' className='text-gray-500 leading-tight'>
        {label}
      </Typography>

      <Typography variant='small' className='text-gray-900 text-sm'>
        {value}
      </Typography>
    </div>
  )
}

Pill.defaultProps = {
  label: '',
  value: ''
}

Pill.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string
}
